// extracted by mini-css-extract-plugin
export default {"faqBlock":"FAQ_faqBlock__T8+1S","mobileName":"FAQ_mobileName__yIlg3"};